// src/data/skins.js

export const SKINS_DATA = [
  // ==========================================
  // SKINS GRATIS / INICIALES
  // ==========================================
  { id: 'bribark', name: 'Bribark Original', cost: 0, img: '/avatars/bribark.png', type: 'bribark' },
  { id: 'dollybelle', name: 'DollyBelle Original', cost: 0, img: '/avatars/dollybelle.png', type: 'dollybelle' },

  // ==========================================
  // COLECCIÓN BRIBARK (TIENDA NORMAL)
  // ==========================================
  { id: 'bribark_gamer', name: 'Bribark Gamer', cost: 200, img: '/avatars/bribarkgamer.png', type: 'bribark' },
  { id: 'bribark_audifonos', name: 'Bribark DJ', cost: 300, img: '/avatars/bribarkaudifonos.png', type: 'bribark' },
  { id: 'bribark_lentes', name: 'Bribark con Estilo', cost: 350, img: '/avatars/bribarklentes.png', type: 'bribark' },
  { id: 'bribark_gorra', name: 'Bribark Urbano', cost: 500, img: '/avatars/bribarkgorra.png', type: 'bribark' },
  { id: 'bribark_skater', name: 'Bribark Skater', cost: 800, img: '/avatars/bribarkskater.png', type: 'bribark' },
  { id: 'bribark_tkd', name: 'Bribark TKD', cost: 1200, img: '/avatars/bribarktkd.png', type: 'bribark' },
  { id: 'bribark_libro', name: 'Bribark Intelectual', cost: 400, img: '/avatars/bribarklibro.png', type: 'bribark' },
  { id: 'bribark_blink', name: 'Bribark Blink', cost: 550, img: '/avatars/bribarkblink.png', type: 'bribark' },
  { id: 'bribark_happy', name: 'Bribark Happy', cost: 600, img: '/avatars/bribarkhappy.png', type: 'bribark' },
  { id: 'bribark_hug', name: 'Bribark Hug', cost: 700, img: '/avatars/bribarkhug.png', type: 'bribark' },

  // ==========================================
  // COLECCIÓN DOLLYBELLE (TIENDA NORMAL)
  // ==========================================
  { id: 'dollybelle_audifonos', name: 'Dolly Music', cost: 300, img: '/avatars/dollybelleaudifonos.png', type: 'dollybelle' },
  { id: 'dollybelle_lentes', name: 'Dolly Intelectual', cost: 350, img: '/avatars/dollybellelentes.png', type: 'dollybelle' },
  { id: 'dollybelle_lentescorazon', name: 'Dolly Love', cost: 450, img: '/avatars/dollybellelentescorazon.png', type: 'dollybelle' },
  { id: 'dollybelle_gorra', name: 'Dolly Sport', cost: 500, img: '/avatars/dollybellegorra.png', type: 'dollybelle' },
  { id: 'dollybelle_flores', name: 'Dolly Primavera', cost: 600, img: '/avatars/dollybelleflores.png', type: 'dollybelle' },
  { id: 'dollybelle_vestido', name: 'Dolly Gala', cost: 1200, img: '/avatars/dollybellevestido.png', type: 'dollybelle' },
  { id: 'dollybelle_libro', name: 'Dolly Sabia', cost: 400, img: '/avatars/dollybellelibro.png', type: 'dollybelle' },
  { id: 'dollybelle_saltarina', name: 'Dolly Saltarina', cost: 550, img: '/avatars/dollybellesaltarina.png', type: 'dollybelle' },
  { id: 'dollybelle_zen', name: 'Dolly Zen', cost: 650, img: '/avatars/dollybellezen.png', type: 'dollybelle' },

  // ==========================================
  // SECRETAS / LEGENDARIAS (COFRE Y LOGROS)
  // ==========================================
  
  // --- BRIBARK SECRETOS ---
  { 
    id: 'bribark_astronauta', 
    name: 'Bribark Astro', 
    cost: 0, 
    img: '/avatars/bribarkastronauta.png', 
    type: 'bribark', 
    isSecret: true, 
    exclusive:true,
    rarity: 'legendary', 
    greeting: '¡Houston, no tenemos ningún problema! El espacio es mío.' 
  },
  { 
    id: 'bribark_futurista', 
    name: 'Bribark Cyber', 
    cost: 0, 
    img: '/avatars/bribarkfuturista.png', 
    type: 'bribark', 
    isSecret:true, 
    exclusive:true,
    rarity: 'legendary',
    greeting: 'Vengo del futuro... y tu inglés es perfecto allí.' 
  },
  { 
    id: 'bribark_ninja', 
    name: 'Bribark Shinobi', 
    cost: 0, 
    img: '/avatars/bribarkninja.png', 
    type: 'bribark', 
    isSecret:true, 
    exclusive:true,
    rarity: 'mythic',
    greeting: 'Silencioso como la noche... rápido como tu mente.'
  },
  { 
    id: 'bribark_samurai', 
    name: 'Bribark Ronin', 
    cost: 0, 
    img: '/avatars/bribarksamurai.png', 
    type: 'bribark', 
    isSecret: true,
    exclusive:true, 
    rarity: 'mythic',
    greeting: 'El honor de un estudiante está en su disciplina.'
  },
  { 
    id: 'bribark_pirata', 
    name: 'Capitán Bribark', 
    cost: 0, 
    img: '/avatars/bribarkpirata.png', 
    type: 'bribark', 
    isSecret: true,
    exclusive:true,
    rarity: 'epic',
    greeting: '¡Arrr! ¡Vamos por ese tesoro de vocabulario!'
  },
  { 
    id: 'bribark_rockstar', 
    name: 'Bribark Rock', 
    cost: 0, 
    img: '/avatars/bribarkrockstar.png', 
    type: 'bribark', 
    isSecret: true,
    exclusive:true,
    rarity: 'epic',
    greeting: '¡Hagamos algo de ruido en esta lección! 🎸'
  },

  // --- DOLLYBELLE SECRETAS ---
  { 
    id: 'dollybelle_astronauta', 
    name: 'Dolly Galaxy', 
    cost: 0, 
    img: '/avatars/dollybelleastronauta.png', 
    type: 'dollybelle', 
    isSecret: true,
    exclusive:true, 
    rarity: 'legendary',
    greeting: 'Las estrellas brillan, pero tú brillas más.'
  },
  { 
    id: 'dollybelle_maga', 
    name: 'Dolly Mística', 
    cost: 0, 
    img: '/avatars/dollybellemaga.png', 
    type: 'dollybelle', 
    isSecret: true, 
    exclusive:true,
    rarity: 'legendary',
    greeting: '¡Abracadabra! Tu fluidez aparecerá mágicamente.'
  },
  { 
    id: 'dollybelle_princesa', 
    name: 'Dolly Real', 
    cost: 0, 
    img: '/avatars/dollybelleprincesa.png', 
    type: 'dollybelle', 
    isSecret: true, 
    exclusive:true,
    rarity: 'mythic',
    greeting: 'Una reverencia, por favor. La clase ha comenzado.'
  },
  { 
    id: 'dollybelle_kpop', 
    name: 'Dolly Idol', 
    cost: 0, 
    img: '/avatars/dollybellekpop.png', 
    type: 'dollybelle', 
    isSecret: true,
    exclusive:true,
    rarity: 'epic',
    greeting: '¡Eres mi fan número uno! Cantemos en inglés.'
  },
  { 
    id: 'dollybelle_gotica', 
    name: 'Dolly Dark', 
    cost: 0, 
    img: '/avatars/dollybellegotica.png', 
    type: 'dollybelle', 
    isSecret: true,
    exclusive:true,
    rarity: 'epic',
    greeting: 'La gramática no me asusta... y a ti tampoco debería.'
  },
  { 
    id: 'dollybelle_guerrera', 
    name: 'Dolly Guerrera', 
    cost: 0, 
    img: '/avatars/dollybelleguerrera.png', 
    type: 'dollybelle', 
    isSecret: true,
    exclusive:true,
    rarity: 'epic',
    greeting: '¡A la batalla! Derrotaremos esos verbos irregulares.'
  }
];

// Helpers útiles
export const getSecretSkins = () => SKINS_DATA.filter(s => s.isSecret);
export const getShopSkins = () => SKINS_DATA.filter(s => !s.isSecret);